module.exports = __webpack_public_path__ + "static/pp_glowny-ad2a28118559cf8feb0102ab11f73b95.gif";